export class TableListPage {
  headers: HeaderRow[];
  rows: TableContentRow[];
  count?: number | null;

  constructor() {
    this.headers = [];
    this.rows = [];
  }
}

export class HeaderRow {
  name: string;

  constructor(name: string) {
    this.name = name;
  }
}

export class TableContentRow {
  data: TableContentData[];
  guid!: string;

  constructor() {
    this.data = [];
  }
}

export class TableContentData {
  id: number;
  valueType: PropertyValueType;
  stringValue?: string;
  intValue?: number;
  dateTimeValue?: Date;
  boolValue?: boolean;

  constructor(
    id?: number,
    value?: string | number | boolean | Date,
    valueType?: PropertyValueType
  ) {
    this.id = id ?? 0;
    this.valueType = valueType ?? PropertyValueType.String;

    switch (this.valueType) {
      case PropertyValueType.String:
        this.stringValue = value as string ?? '';
        break;
      case PropertyValueType.Int:
        this.intValue = value as number ?? null;
        break;
      case PropertyValueType.Date:
        this.dateTimeValue = value as Date ?? null;
        break;
      case PropertyValueType.Bool:
        this.boolValue = value as boolean ?? null;
        break;
    }
  }
}

export enum PropertyValueType {
  Int = 0,
  String = 1,
  Bool = 2,
  Date = 3
}
